import useMyPermissions from './useMyPermissions';

function useOrganizationAccess() {
  const { hasAccess, isInitialLoading, isRefetching, error, refetch, networkStatus } = useMyPermissions();

  return {
    hasAccess,
    isInitialLoading,
    isRefetching,
    error,
    refetch,
    networkStatus
  };
}

export default useOrganizationAccess;
